import { useToastContext } from "components/alert/ToastContext";
import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import Produto from "model/administracao/cadastro/produto/Produto";
import AjusteEstoque from "model/suprimentos/AjusteEstoque";
import Deposito from "model/suprimentos/Deposito";
import Estoque from "model/suprimentos/Estoque";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import Transacao from "model/suprimentos/Transacao";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { Tooltip } from "primereact/tooltip";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import ContaParametroService from "service/administracao/cadastro/ContaParametroService";
import AjusteEstoqueService from "service/suprimentos/AjusteEstoqueService";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    style?: React.CSSProperties | undefined;
    estoque: Estoque;
    rowIndex: number;
    onConfirm: () => void;
}

const ajusteEstoqueService = new AjusteEstoqueService();
const contaParametroService = new ContaParametroService();
export default function AjusteEstoqueModal(props: Props) {

    const [ajusteEstoque, setAjusteEstoque] = useState<AjusteEstoque>(new AjusteEstoque());
    const [transacoesDisponiveis, setTransacoesDisponiveis] = useState<Transacao[]>([]);
    const { msgAlerta, msgSucesso } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [temIntegracao, setTemIntegracao] = useState<boolean>(false);

    useEffect(() => {
        if (props.visible) {
            setAjusteEstoque({
                ...ajusteEstoque,
                deposito: props.estoque.deposito,
                produto: props.estoque.produto,
                ...(props.rowIndex >= 0 && {
                    lote: props.estoque.lotes[props.rowIndex]
                })
            });
            contaParametroService.buscarParametro('URL_DATABASE_YOUPRATICO').then((data) => {
                setTemIntegracao(data as unknown as boolean);
            }).catch((error) => {
                console.log(error);
            })
        }
    }, [props.visible, props.estoque, props.rowIndex]);

    useEffect(() => {
        if (!props.visible) {
            setAjusteEstoque(new AjusteEstoque());
        }
    }, [props.visible, props.estoque]);

    useEffect(() => {
        if (ajusteEstoque.tipo) {
            ajusteEstoqueService.getTransacoes(ajusteEstoque.tipo).then((data) => {
                setTransacoesDisponiveis(data)
            }).catch((error) => {
                console.log(error);
            });
        }

        if (ajusteEstoque.tipo) {
            ajusteEstoqueService.getTransacaoPadrao(ajusteEstoque.tipo).then((data) => {
                setAjusteEstoque({ ...ajusteEstoque, transacao: data });
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [ajusteEstoque.tipo])

    function ajustar() {
        if (!podeAjustar()) {
            return;
        }
        if (ajusteEstoque.tipo === "ENTRADA") {
            ajusteEstoque.lote.produto = ajusteEstoque.produto;
            ajusteEstoque.lote.deposito = ajusteEstoque.deposito;
        }
        startLoading();
        ajusteEstoqueService.ajustar(ajusteEstoque).then(() => {
            stopLoading();
            msgSucesso("Ajuste de estoque", "Ajuste realizado com sucesso");
            setAjusteEstoque(new AjusteEstoque);
            props.onConfirm();
            fechar();
        }).catch((error) => {
            stopLoading();
            console.log(error)
            msgAlerta("Ajuste de estoque", error.data.message);
        });
    }

    function podeAjustar() {
        if (ajusteEstoque.tipo === null || ajusteEstoque.tipo === '') {
            msgAlerta("Tipo", "Informe o tipo");
            return false;
        }

        if (ajusteEstoque.transacao === null || ajusteEstoque.transacao.codigo === null) {
            msgAlerta("Transação", "Informe a transação");
            return false;
        }
        if (ajusteEstoque.deposito === null || ajusteEstoque.deposito.codigo === null) {
            msgAlerta("Depósito", "Informe o depósito");
            return false;
        }
        if (ajusteEstoque.produto == null || !ajusteEstoque.produto.codigo) {
            msgAlerta("Produto", "Informe o produto");
            return false;
        }

        if (!ajusteEstoque.lote || !ajusteEstoque.lote.lote) {
            msgAlerta("Lote", "Informe o lote");
            return false;
        }

        if (ajusteEstoque.quantidade == 0) {
            msgAlerta("Quantidade", "Informe a quantidade");
            return false;
        }

        return true;
    }

    const fechar = () => {
        props.setVisible(false);
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }


    return (
        <Dialog header="Ajuste de Estoque" visible={props.visible} style={{ width: '35vw', ...props.style }} onHide={() => { fechar() }}>
            <div className="row">
                <label className="col col-sm-12">
                    Produto: {ajusteEstoque.produto?.nome}
                </label>
                <label className="col col-sm-12">
                    Depósito: {ajusteEstoque.deposito.nome}
                </label>
                <label className="col col-sm-12">
                    Lote: {ajusteEstoque.lote?.lote}
                </label>
            </div>

            {temIntegracao ? <div style={{ display: "flex", marginTop: 12, alignItems: "center" }}>
                <Checkbox style={{ marginRight: 8 }} checked={ajusteEstoque.integrado} onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, integrado: e.checked as boolean })} />
                <label style={{marginRight: 8}}>Integrado</label>
                
                <Tooltip target=".custom-target-icon" position="top" />
                <Badge value="!" className="custom-target-icon" severity="info" data-pr-tooltip="Caso marque esse check, o movimento de estoque não será integrado no You Prático"></Badge>

            </div> : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                <div className="col-sm-12">
                    <Dropdown
                        value={ajusteEstoque.tipo} options={ajusteEstoqueService.getTiposTransacao()}
                        optionLabel="label" optionValue="value" placeholder="Selecione o tipo de ajuste"
                        onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, tipo: e.value, transacao: new Transacao() })} style={{ width: '70%' }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12" >Transação</Label>
                <div className="col-sm-12">
                    <Dropdown value={ajusteEstoque.transacao}
                        options={transacoesDisponiveis} optionLabel="descricao" placeholder="Selecione a transação"
                        onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, transacao: e.value })} style={{ width: '70%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" >Quantidade</Label>
                <div className="col-sm-12">
                    <InputNumber value={ajusteEstoque.quantidade} useGrouping={false}
                        onFocus={(e) => e.target.select()}
                        locale="pt-BR"
                        minFractionDigits={1} maxFractionDigits={5} maxLength={10}
                        onChange={(e) => {
                            ajusteEstoque.quantidade = e.value;
                            setAjusteEstoque({ ...ajusteEstoque })
                        }}
                        style={{ width: '70%' }}
                    />
                </div>
            </div>
            <div className="row" style={{ width: '73%' }}>
                <Label className="col col-sm-12" >Valor Unitário</Label>
                <div className="col-sm-12">
                    <InputMonetario value={ajusteEstoque.valorUnitario || 0}
                        onChange={(e) => {
                            ajusteEstoque.valorUnitario = e;
                            setAjusteEstoque({ ...ajusteEstoque })
                        }}

                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Observação</label>
                <div className="col-sm-12" style={{ width: '73%' }}>
                    <InputTextarea
                        required value={ajusteEstoque.observacao || ''}
                        style={{ width: '100%' }}
                        rows={4}
                        onChange={(e) => {
                            setAjusteEstoque({ ...ajusteEstoque, observacao: e.target.value })
                        }}
                    />
                </div>
            </div>

            <div className="row" style={{ marginTop: 20 }}>
                <div className="col col-sm-12">

                    <Button label="Ajustar" onClick={() => {
                        ajustar();
                    }}></Button>
                </div>
            </div>
        </Dialog>
    )
}